import { Heart, Bell, Users } from 'lucide-react'

const HeroSection = () => {
  return (
    <section className="section-padding bg-gradient-to-r from-primary to-blue-600 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-white/20 p-4 rounded-full">
            <Heart className="w-12 h-12 text-white" />
          </div>
        </div>
        
        <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
          Få besked når din læge
          <span className="block text-secondary">åbner for nye patienter</span>
        </h1>
        
        <p className="text-xl md:text-2xl mb-8 text-blue-100 max-w-3xl mx-auto">
          Gratis automatiske notifikationer via Telegram når læger på findlæge.dk 
          bliver tilgængelige for nye patienter
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a 
            href="https://t.me/NyLaegeBot" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn-secondary text-lg px-8 py-4 inline-flex items-center"
          >
            <Bell className="w-5 h-5 mr-2" />
            Start med Telegram Bot
          </a>
          <p className="text-blue-100 text-sm">
            100% gratis • Ingen registrering • Kun Telegram påkrævet
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="text-center">
            <div className="bg-white/10 p-3 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <Bell className="w-8 h-8" />
            </div>
            <h3 className="text-lg font-semibold mb-2">Øjeblikkelige notifikationer</h3>
            <p className="text-blue-100">Få besked samme dag når din læge åbner</p>
          </div>
          
          <div className="text-center">
            <div className="bg-white/10 p-3 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <Heart className="w-8 h-8" />
            </div>
            <h3 className="text-lg font-semibold mb-2">Helt gratis</h3>
            <p className="text-blue-100">Ingen skjulte omkostninger eller abonnementer</p>
          </div>
          
          <div className="text-center">
            <div className="bg-white/10 p-3 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <Users className="w-8 h-8" />
            </div>
            <h3 className="text-lg font-semibold mb-2">Nem opsætning</h3>
            <p className="text-blue-100">Kun 2 minutter at komme i gang</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroSection